export default "__VITE_ASSET__EBCDjWEM__"